
import { Injectable} from '@angular/core';
import { ApiServiceProvider} from "./api.service";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import { Storage } from '@ionic/storage';
// import {asObservable} from "./asObservable"



export interface Participant{
  username :string;
  password?:string;
  name? : string;
  email? : string;
  comments? :string;
  creationTime? : number;
  author? : string;
  authenticationToken?:string;
  identificationToken?: string;
  variables?:string;
  groups?:Array<string>;
}

export interface Document{
  name :string;
  is : string,
  properties: Object,

  type : string,
  comments : string,
  creationTime : number;
  //author is a researcher's userID?
  author : string;

  config:Object;
  identificationToken: string; //identificationToken defines the researcher
  shortid: string; //shortid should define the group

  referencedNames : Array<string>;
  outerHTML : string;
}

@Injectable()
export class GlobalServiceProvider {


  public participantsByUsername:Object= {};
  public participantSubject = new Subject<Participant>();
  public shouldFetchParticipants:boolean = true;


  public documentsByName:Object={};
  public documentSubject = new Subject<Document>();
  public shouldFetchDocuments:boolean = true;

  public getParticipantObservable():Observable<Participant>{
    return this.participantSubject.asObservable();
  }

  public getDocumentObservable():Observable<Document>{
    return this.documentSubject.asObservable();
  }


  public identificationToken;

  constructor(private api : ApiServiceProvider, private storage:Storage) {
    console.log("hey!")

  }




  fetchParticipants(criteria?){
    if(this.shouldFetchParticipants) {
      this.api.participants.get().then(result => {
        for (var i = 0; i < result.length; i++) {
          let username = result[i].username;
          if(!this.participantsByUsername[username]) {
            this.participantsByUsername[username] = result[i];
          }
          this.participantSubject.next(this.participantsByUsername[username]);
        }
      }).catch(getParticipantsError => {
        console.error(getParticipantsError);
      });
    }
  }

  createParticipant(pObj?:Participant) {
    return new Promise((resolve, reject)=>{
      this.api.participants.post(pObj).then((result)=>{
        this.participantsByUsername[pObj.username] = pObj;
        this.participantSubject.next(this.participantsByUsername[pObj.username]);
        resolve(this.participantsByUsername[pObj.username]);
      }).catch(participantPostError=>{
        reject(participantPostError);
      })

    })
  }


  fetchDocuments(criteria?){
    if(this.shouldFetchDocuments) {
      this.api.elements.get().then(result => {
        for (var i = 0; i < result.length; i++) {
          let name = result[i].name;
          if(!this.documentsByName[name]) {
            this.documentsByName[name] = result[i];
          }
          this.documentSubject.next(this.documentsByName[name]);
        }
      }).catch(getDocumentsError => {
        console.error(getDocumentsError);
      });
    }
  }

  createDocument(pObj?:Document) {
    return new Promise((resolve, reject)=>{
      this.api.elements.post(pObj).then((result)=>{
        this.documentsByName[pObj.name] = pObj;
        this.documentSubject.next(this.documentsByName[pObj.name]);
        resolve(this.documentsByName[pObj.name]);
      }).catch(documentPostError=>{
        reject(documentPostError);
      })

    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/global.service.ts